import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function Shipping() {
  return <section id="shipping" className="border-t border-border bg-background py-16 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="border border-border bg-card p-6 sm:p-10 lg:p-14">
          <div className="max-w-4xl space-y-6">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 bg-primary" aria-hidden="true" />
              <span className="font-mono text-xs uppercase tracking-widest text-primary font-medium">
                Logistics &amp; Fulfillment
              </span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold uppercase tracking-tight text-foreground">
              Shipping and Ordering a Mechanical Bull
            </h2>

            <div className="space-y-4 text-base sm:text-lg leading-relaxed text-muted-foreground">
              <p>
                Mechanical bulls are large equipment purchases, so delivery arrangements depend on the actual machine, package, destination and receiving requirements. Review the product first, then provide the delivery information needed for the order enquiry.
              </p>
              <p>
                Complete mechanical bulls use our Request a Quote process rather than a standard online checkout. This allows the selected product, current price and delivery details to stay attached to the enquiry.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row flex-wrap items-stretch sm:items-center gap-4 pt-4">
              <Button asChild variant="outline" className="font-serif uppercase tracking-wider text-base h-auto py-3.5 px-6">
                <Link to="/ShippingWarrantyAndOrderingPage">
                  VIEW SHIPPING INFORMATION
                </Link>
              </Button>
              <Button asChild className="font-serif uppercase tracking-wider text-base h-auto py-3.5 px-6 bg-primary text-primary-foreground hover:bg-primary/90">
                <Link to="/RequestQuotePage">
                  REQUEST A QUOTE
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}